import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import DataTable from '../../../juristec-ui/core/DataTable';
import IconButton from '../../../juristec-ui/core/IconButton';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import {
  Download, Excel, Pdf, Update, Word,
} from '../../../juristec-ui/icons';
import { formatDateTime } from '../../../juristec-ui/utils/functions/lab';

import {
  ReportsContainer,
} from './styled/ExtractedReports.styled';

const ExtractedReports = ({ reports, downloadReport, updateReport }) => {
  const theme = useTheme();

  const iconMap = {
    pdf: <Pdf />,
    docx: <Word />,
    xlsx: <Excel />,
  };

  const reportOptions = (report) => (
    <>
      <Tooltip text="Baixar relatório">
        <IconButton
          onClick={() => downloadReport(report.id, report.output_format)}
          shape="rounded"
          color="primary"
          variant="pattern"
        >
          <Download />
        </IconButton>
      </Tooltip>
      <Tooltip text="Atualizar relatório">
        <IconButton
          onClick={() => updateReport(report.id, report.output_format)}
          shape="rounded"
          color="primary"
          disabled={!report.updatable}
          variant="pattern"
        >
          <Update />
        </IconButton>
      </Tooltip>
    </>
  );

  const columns = [
    {
      field: 'label',
      label: `Relatórios Extraídos (${reports.length})`,
      sortable: true,
    },
    {
      field: 'original_file',
      label: 'Arquivo Pai',
      sortable: true,
    },
    {
      field: 'output_format',
      label: 'Formato',
      sortable: true,
      valueGetter: (param) => iconMap[param.output_format],
    },
    {
      field: 'createdAt',
      label: 'Criado em',
      sortable: true,
      valueGetter: (param) => formatDateTime(param.createdAt, { time: 'half' }),
    },
    {
      field: 'extractedAt',
      label: 'Extraído em',
      sortable: true,
      valueGetter: (param) => formatDateTime(param.extractedAt, { time: 'half' }),
    },
    {
      field: 'options',
      label: 'Opções',
      valueGetter: (param) => reportOptions(param),
    },
  ];

  return (
    <ReportsContainer>
      <DataTable
        columns={columns}
        rowData={reports}
        rowColor={theme.tableBackground}
        strippedRowsColor={theme.containerOdd}
        defaultSortField="createdAt"
        defaultSortDirection="desc"
        headerColor="transparent"
        theadStyle={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: theme.background,
        }}
      />
    </ReportsContainer>
  );
};

ExtractedReports.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    output_format: PropTypes.string.isRequired,
  })).isRequired,
  downloadReport: PropTypes.func.isRequired,
  updateReport: PropTypes.func.isRequired,
};

export default ExtractedReports;
